import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import { AssetHeaderDesktop as AssetHeader } from '../../components/asset-header/desktop';

import { AssetHeaderContainer as Component } from './component';
import type {
    IDepsDesktop,
    TInvestMediaportalEmitentsDetailPageAssetHeaderDesktop,
} from './models';

export const InvestMediaportalEmitentsDetailPageAssetHeaderDesktop = createWidgetWithErrorBoundary<
    IDepsDesktop,
    TInvestMediaportalEmitentsDetailPageAssetHeaderDesktop
>({
    AssetHeader,
})(Component);
